import React, { useMemo, useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getTituloVista } from "./tituloVista";
import VerticalSidebar from "./VerticalSidebar.jsx";
import SolicitarCambioButton from "../solicitudes-cambio/SolicitarCambioButton.jsx";
import { usePuedeSolicitarCambios } from "../../context/PermisosContext";
import "../../styles.css";

export default function AppHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname || "/";

  const [histIdx, setHistIdx] = useState(() => window.history.state?.idx ?? 0);
  const maxHistIdxRef = useRef(histIdx);

  const isElectron = useMemo(() => typeof window !== "undefined" && !!window.electronAPI, []);

  useEffect(() => {
    const idx = window.history.state?.idx ?? 0;
    if (idx > maxHistIdxRef.current) maxHistIdxRef.current = idx;
    setHistIdx(idx);
  }, [location]);

  const pageTitle = useMemo(() => getTituloVista(pathname), [pathname]);
  const puedeSolicitarCambios = usePuedeSolicitarCambios();

  const canGoBack = histIdx > 0;
  const canGoForward = histIdx < maxHistIdxRef.current;

  return (
    <>
      <VerticalSidebar />

      <header className="eh-root eh-root--compact">
        <div className="eh-bar eh-bar--compact">
          <div className="eh-nav-history electron-no-drag">
            <button
              type="button"
              className={`eh-nav-history-btn${canGoBack ? "" : " disabled"}`}
              onClick={() => canGoBack && navigate(-1)}
              aria-label="Atras"
              title="Atras"
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>
            <button
              type="button"
              className={`eh-nav-history-btn${canGoForward ? "" : " disabled"}`}
              onClick={() => canGoForward && navigate(1)}
              aria-label="Adelante"
              title="Adelante"
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>
          </div>

          {pageTitle && <h1 className="eh-page-title">{pageTitle}</h1>}

          <div className="eh-right electron-no-drag" style={{ marginLeft: "auto" }}>
            {puedeSolicitarCambios && <SolicitarCambioButton />}
            {isElectron && (
              <div className={`eh-win${puedeSolicitarCambios ? " eh-win--con-solicitud" : ""}`}>
                <button className="eh-win-btn" title="Minimizar" onClick={() => window.electronAPI?.minimize?.()}>🗕</button>
                <button className="eh-win-btn" title="Maximizar/Restaurar" onClick={() => window.electronAPI?.maximize?.()}>🗖</button>
                <button className="eh-win-btn close" title="Cerrar" onClick={() => window.electronAPI?.close?.()}>✕</button>
              </div>
            )}
          </div>
        </div>
        <div className="eh-drag-overlay" />
      </header>
    </>
  );
}
